export default {"src":"/_next/static/media/RightArrow.81b0a551.svg","height":12,"width":8,"blurWidth":0,"blurHeight":0};